<template>
    <BaseTableColumn showEdit
                     :readOnly="readOnly"
                     :adUnit="adUnit"
                     :placementId="placement.id"
                     name="Reward"
                     @edit="$emit('edit')">
        <span v-if="exception.reward" class="font-4">
            {{exception.reward}} {{placement.virtualItemName}}
        </span>
        <span v-if="placement.virtualItemName" :class="{ overridden }" class="inactive">
            {{placement.virtualItemCount}} {{placement.virtualItemName}}
        </span>
    </BaseTableColumn>
</template>

<script>
import BaseTableColumn from '@/pages/monetize/segments/segmentForm/columns/BaseTableColumn.vue';

export default {
    name: 'RewardColumn',
    components: { BaseTableColumn },
    props: {
        placement: {
            type: Object,
            default: () => ({})
        },
        exception: {
            type: Object,
            default: () => ({})
        },
        readOnly: Boolean,
        adUnit: String
    },
    computed: {
        overridden() {
            return this.exception.reward && this.exception.reward !== this.placement.virtualItemCount;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.scss";

.inactive {
    color: $light-800;
}

.overridden {
    text-decoration: line-through;
    margin-left: 5px;
}
</style>
